













import { Component, Mixins, Prop } from "vue-property-decorator";
import { DisableableMixin } from "../../../system/mixins";
import CircleSelectObject from "../../../document/editor/objects/CircleSelectObject.vue";
import CircleSelectInputMethodSelector from "./CircleSelectInputMethodSelector.vue";
import InputMethodEditCheckBox from "./InputMethodEditCheckBox.vue";

@Component({
  components: {
    CircleSelectInputMethodSelector,
    InputMethodEditCheckBox,
  }
})
export default class CircleSelectInputMethodEditor extends Mixins(DisableableMixin) {
  @Prop()
  source: CircleSelectObject;

  get selected(): boolean {
    return this.source.shouldInputFree;
  }

  set selected(value: boolean) {
    this.source.shouldInputFree = value;
  }
}
